import {FormControl, FormControlProps, FormLabel} from '@chakra-ui/form-control'
import {Switch as ChakraSwitch, SwitchProps} from '@chakra-ui/switch'
import {forwardRef} from '@chakra-ui/system'
import * as React from 'react'

import StyleProps from 'airship/design-system/style-props'

import {Box} from '../box'

export type Props = Pick<FormControlProps, 'label'> &
  Pick<
    SwitchProps,
    | 'isChecked'
    | 'id'
    | 'isDisabled'
    | 'isReadOnly'
    | 'isInvalid'
    | 'isRequired'
    | 'name'
    | 'size'
    | 'onChange'
    | 'value'
    | 'children'
    | 'variant'
    | '__css'
  > &
  StyleProps

const Switch = forwardRef<Props, React.FC>((props, ref) => {
  return (
    <Box>
      <FormControl
        isDisabled={props.isDisabled}
        isReadOnly={props.isReadOnly}
        isRequired={props.isRequired}
        isInvalid={props.isInvalid}
      >
        {props.label && <FormLabel>{props.label}</FormLabel>}
        <ChakraSwitch {...props} ref={ref} />
      </FormControl>
    </Box>
  )
})

/* The use of React.ForwardRefExoticComponent<Props> may seem odd here.
This has been added to make sure that storybook's addon-docs plugin can access the props
to build this component's storybook page. Please make sure that any changes here do
not make props inaccessible to storybook. */
export default Switch as React.ForwardRefExoticComponent<
  Props & React.RefAttributes<React.FC>
>
